import { httpBus } from "@/api/index.js";
export { list as queryStationList } from '@/api/modules/station/index.js';
export { getMeterList as queryMeterList } from '@/api/modules/device/meter.js';
import dayjs from 'dayjs';


/**
 * 获取行政区域信息
 * 省-市
 * @returns 
 */
export function queryAdRegionInfo() {
  return httpBus.request("get", "/schedule/job/weather/district/queryProvinceCity");
}


/**
 * 查询：一年中的特殊日期
 * >>> 默认查询：法定节假日 | 法定调班日
 * @param {*} year '2025'
 * @param {*} typeList []  1:星期六,2:星期日,3:节假日,4:补班日
 * @returns 
 */
export function querySpecialDaysForYear(year, typeList = [3, 4]) {
  const params = {
    year: dayjs(year).format('YYYY'),
    range: typeList.join(',')
  }
  return httpBus.request("get", "/command/meterRatePeriod/getSpecialDates", {
    params,
  });
}


/**
 * 提交：创建电表时段的内容
 * @param {*} params 
 * @returns 
 */
export function commitCreateData(params) {
  return httpBus.request("post", "/command/meterRatePeriod/saveStandard", {
    data: params,
  });
}


/**
 * 查询：电表的时段信息【对应地区&一整年的】
 * @param {*} year 
 * @param {*} adcode 
 * @returns 
 */
export function queryMeterSegmentsInfo(year, adcode) {
  const params = {
    year: dayjs(year).format('YYYY'),
    provinceCode: adcode,
  }
  return httpBus.request("get", "/command/meterRatePeriod/getStandard", {
    params,
  });
}



/**
 * 提交：下发绑定关系
 * @param {*} params 
 * @returns 
 */
export function commitBoundData(params) {
  return httpBus.request("post", "/command/meterRatePeriod/issueRate", {
    data: params,
  });
}


/**
 * 获取：eMind下发给电表的时段数据
 * @param {*} uuid 
 * @returns 
 * >>> res.data.local：gemini下发给服务的配置信息
 * >>> res.data.remote：服务下发给eLink的配置信息
 *     >>> 如果 [res.data.remote.traceingNo] 和 [queryEfficientInfoForMeter]返回的[res.data] 一致
 *         >>> res.data.remote 和 eLink设置给电表 的配置信息一致
 *         >>> 认为 res.data.remote 是 电表正在生效的 配置信
 */
export function queryIssuedInfoForMeter(uuid) {
  const params = {
    uuid,
  }
  return httpBus.request("get", "/command/meterRatePeriod/getMeterSetting", {
    params,
  });
}


/**
 * 获取：电表当前实际运行的时段数据
 * @param {*} uuid 
 * @param {*} year 
 * @param {*} devId 
 * @param {*} productModel 
 * @returns 
 * >>> res.data: 服务端 读取 eLink端 电表数据时，创建的钥匙链。用于判断eLink返回的数据，是否是eLink发起请求对应的数据。
 * >>> 该请求发起后，需要尝试发起多次 [queryIssuedInfoForMeter] 请求，获取读取到的数据。
 *     >>> 读取eLink比较耗时，如果获取的数据不是本次读取的，间隔3s再次尝试，尝试5次后还获取不到，终止。
 */
export function queryEfficientInfoForMeter({year, devId, uuid, productModel}) {
  const params = {
    year, 
    devId, 
    uuid, 
    productModel,
  }
  return httpBus.request("get", "/command/meterRatePeriod/getRemoteMeterSetting", {
    params,
  });
}


/**
 * 获取电报远程设置的操作历史记录
 * @param {*} uuid 电表的UUID
 * @param {*} year 
 * @param {*} pageNum 
 * @param {*} pageSize 
 * @returns 
 */
export function queryHistoryLog({startDate, endDate, uuid, createBy, pageNum, pageSize}) {
  const params = {
    startDate,
    endDate,
    uuid,
    createBy, 
    pageNum, 
    pageSize
  }
  return httpBus.request("get", "/command/meterRatePeriod/getSettingRecord", {
    params,
  });
}



